// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'
import FilePlayer from 'react-player/lib/players/FilePlayer'

// Internal Dependencies:
import Editable from 'components/Editable/Editable'
import Image from 'components/Image/Image'
import MediaPlayer from 'components/MediaPlayer/MediaPlayer'
import Curve from 'components/svg/bg/rounded-background.svg'
import { get } from 'utilities/objects'

class Hero extends React.Component {
	render() {
		const { contentId, sectionId, data } = this.props

		if ( ! data ) {
			return null
		}

		const bgTop = get( ['settings', 'bg_top'] )( data, '' )
		const bg = get( ['settings', 'bg'] )( data, '' )
		const limitBgToPageTop = get( ['settings', 'limit_bg_to_page_top'] )( data, '' )
		const bgPositionBottom = get( ['settings', 'bg_position_bottom'] )( data, '' )
		const fullData = {
			image: data.image || {
				url: '',
				alt: '',
				aspect_ratio: '',
				focal_point: '',
				copy_space: '',
				width: '',
				height: '',
				thumb: '',
				srcset: '',
				type: '',

				// Video:
				id: '',
				service: '',
				thumb_url: ''
			},
			content: data.content || '',
			bg: data.bg || ''
		}

		let copySpaceData = new Array( 3 )

		if ( fullData.image.copy_space && Object.keys( fullData.image.copy_space ).length ) {
			Object.keys( fullData.image.copy_space ).map( ( key, i ) => {
				copySpaceData[ i ] = fullData.image.copy_space[ key ]
			} )
		}

		let styleCurve = {}
		let styleTop = {
			background: bgTop
		}
		let style = {
			background: bg
		}

		if ( bgPositionBottom ) {
			styleCurve.bottom = bgPositionBottom
		}

		return [
			<div className="-bg" key="hero_bg">
				<div className="-bg-inner"></div>
			</div>,

			<div className="section-hero" style={ style } key="hero">
				<div className="-inner">
					{ '1' == limitBgToPageTop &&
						<div className="-curve" style={ styleCurve }>
							<div className="-curve-bg" style={ styleTop }></div>
							<Curve />
						</div>
					}

					<div className="-text">
						<Editable
							element="h1"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="content"
							content={ fullData.content }
						/>
					</div>

					<Editable
						id={ contentId }
						sectionId={ sectionId }
						sectionType={ data.type }
						sectionDataId="image"
						className="-image"
						imageId={ fullData.image.id }
					>
						{ '1' != limitBgToPageTop &&
							<div className="-curve">
								<div className="-curve-bg" style={ styleTop }></div>
								<Curve />
							</div>
						}

						{ 'video' == fullData.image.type &&
							<div className="-video">
								<FilePlayer
									playing={ true }
									url={ fullData.image.url }
									loop={ true }
									controls={ false }
									muted={ true }
									volume={ 0 }
								/>
							</div>
						|| 'external_video' == fullData.image.type &&
							<div className="-video">
								<MediaPlayer
									key={ fullData.image.id }
									id={ fullData.image.id }
									service={ fullData.image.service }
									url={ fullData.image.url }
									thumb_url={ fullData.image.thumb_url }
									playing={ true }
									loop={ true }
									controls={ false }
									muted={ true }
									volume={ 0 }
								/>
							</div>
						||
							<Image
								thumb={ fullData.image.thumb }
								url={ fullData.image.url }
								srcset={ fullData.image.srcset }
								srcsetWebp={ fullData.image.srcset_webp }
								sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
								alt={ fullData.image.alt }
								focalPoint={ fullData.image.focal_point }
								width={ fullData.image.width }
								height={ fullData.image.height }
								borderRadius={ fullData.image.border_radius }
								boxShadow={ fullData.image.box_shadow }
							/>
						}
					</Editable>
				</div>
			</div>
		]
	}
}

export default Hero



// WEBPACK FOOTER //
// ./components/PageSections/Hero.jsx